import {BaseContainerModel} from '../base-container.model';
import {
  app_login_principal_RowClass,
  app_login_subject_ext_RowClass,
  app_login_subject_RowClass
} from '../../dbschema/index';

export class AppLoginSubjectContainerModel extends BaseContainerModel {
  appLoginSubject: app_login_subject_RowClass = new app_login_subject_RowClass();
  appLoginSubjectExtList: app_login_subject_ext_RowClass[] = [];
  appLoginPrincipalList: app_login_principal_RowClass[] = [];
}

